// REACT
import React from "react";

// MATERIAL-UI
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// COMPONENTS
import QRModalMobile from "./QRModalMobile";
import QRModalDesktop from "./QRModalDesktop";

// ASSETS
import { QrmodalProps } from "src/components/wallets/common/types/qrModalTypes";

const QrModal = (props: QrmodalProps) => {
  // IS MOBILE VARIABLE
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      {isMobile ? (
        <QRModalMobile
          token={{
            code: props.token.code,
            name: props.token.name,
            logoUrl: props.token.logoUrl,
            address: props.token.address,
            format: props.token.format,
            memo: props.token.memo,
            depositable: props.token.depositable,
            id: props.token.id,
          }}
          loading={props.loading}
          error={props.error}
          open={props.open}
          onClose={props.onClose}
        />
      ) : (
        <QRModalDesktop
          token={{
            code: props.token.code,
            name: props.token.name,
            logoUrl: props.token.logoUrl,
            address: props.token.address,
            format: props.token.format,
            memo: props.token.memo,
            depositable: props.token.depositable,
            id: props.token.id,
          }}
          loading={props.loading}
          error={props.error}
          open={props.open}
          onClose={props.onClose}
        />
      )}
    </>
  );
};

export default QrModal;
